
    import {defineComponent, reactive, computed, ComputedRef, watch} from 'vue'
    import {useRoute} from "vue-router";
    import {useStore} from "@/store";
    import  reportMsgUt from "@/util/reportMsg";
    import { Tab, Tabs } from 'scvant';

    interface State {
        activeName: string;
        contentTextRender: object;
        contentText: object;
        contentText20240514: object;
        contentText20240702: object;
        reportTemplate: string;
        orderDate: number;
        reportMsg: object;
        reportFreeCheckVersion: any;
        version240530: any;
        version240702: any;
        version240704: any;
        formatOrderDate: any;
        isRenderVersion241226: any;
    }
    export default defineComponent({
        name: "explainFreeCheck",
        components: {
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        },
        setup() {
            let state: State = reactive({
                reportTemplate: '',
                activeName: '90天收购保障范围',
                orderDate: 0,
                contentTextRender: {},
                contentText: {},
                contentText20240514: {},
                contentText20240702: {},
                reportMsg: {},
                reportFreeCheckVersion: null,
                version240530: 0,
                version240702: 0,
                version240704: 0,
                formatOrderDate: 0,
                isRenderVersion241226: false,
            })
            // 格式化时间
            function formatDate(dateTime) {
                if(!dateTime) {
                    return 0;
                }
                let reg1 = /[- :]/g;
                let dateNum = Number(dateTime.replace(reg1, ''));
                return dateNum
            }
            state.reportMsg = reportMsgUt;
            let store = useStore()
            let version241226 = computed(() => {
                return store.state.version241226 || 0
            })
            const {query} = useRoute();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {orderDate} = data;
                state.isRenderVersion241226 = true;
                // if (orderDate) {
                //     state.isRenderVersion241226 = formatDate(orderDate) >= version241226.value;
                // }
            }, {immediate: true})
            if (state.isRenderVersion241226) {
                state.reportTemplate = 'v241226';
            } else {
                state.reportTemplate = 'default'
            }
            
            
            state.contentText = {
                'default': 
                [
                    {
                        title: '保障内容',
                        content: [
                            '自购买日期当日(以合同签订日期为准)起90天内，经具备相关资质的第三方鉴定，证明您（购买方）所购买车辆实际车况有以下情况的：',
                            '1. 购买车辆实际车况与我方质检报告严重不符',
                            '2. 购买车型实际年款/配置与购买时年款/配置不符',
                            '3. 购买车型在购买日期前里程表被更改',
                            '且以上任一情形我方未以书面形式告知你（购买方），我方同意对购买方购买车型原价(以原合同载明的转让价格为准)回购，或按照协议说明进行相应补偿。',
                            '您（购买方）同意所购买车型可能存在的以上三种情况不构成我方的欺诈行为。',
                        ]
                    },
                    {
                        title: '补偿标准',
                        content: [
                            '1. 购买车型在购买日期前里程表被更改：',
                            '补偿标准：我方按照每公里1元进行补偿，最高补偿金额1万元，里程明确告知除外。',
                            '2. 购买车型实际年款/配置与购买时年款/配置不符',
                            '补偿标准：我方按照您所购买车辆指导价与车辆实际指导价的差额的50%进行补偿。',
                            '3. 购买车辆实际车况与我方质检报告严重不符',
                            '经有相关机动车鉴定资质的第三方公司鉴定，此车为重大事故车、火烧车、水泡车， 且我方质检报告当中未体现以上真实车况的，予以以下补偿。',
                            '补偿标准：我方按照您（购买方）实际购买价格原价回购。',
                        ]
                    },
                    {
                        title: '备注',
                        content: [
                            '1. 自购买协议签订日期起90天内我方对车辆原价回购，第91天0点开始，我方不再为您（购买方）购买车辆可能存在的 以上3种问题进行原价回购，但对补偿内容承担终身责任。',
                            '2. 若您购买车型进行分期的，在享受我方提供的90天原价回购政策前，您（购买方）需自行结清分期贷款并承担贷款违约责任。',
                            '3. 如本协议约定的90天期间内，因您（购买方）原因造成影响甲方再次销售的车况改变，我方不再回购车辆，但非因您方（购买方）原因且符合本协议补偿标准的情形，我方依旧承担补偿责任。',
                            '4. 本协议期间内发生的纠纷双方应协商解决，如您（购买方）寻找媒体、舆论发酵纠纷事件，则我方不承担本协议项下任何责 任，您（购买方）可向法院起诉解决。',
                            '5. 如车辆存在本协议项下载明应补偿的情况，我方应按照本协议约定进行赔付，但您（购买方）向法院起诉索赔的情形应以法院出具的书面文书(判决书、裁定等)为准，本协议在您（购买方）向法院起诉时即刻失效。',
                            '6. 本协议与原合同不一致的，以原合同为准。',
                        ]
                    },
                ],
                'v241226': 
                [
                    {
                        title: '保障内容',
                        content: [
                            '自购买日期当日(以合同签订日期为准)起90天内，经具备相关资质的第三方鉴定，证明您（购买方）所购买车辆实际车况有以下情况的：',
                            '1. 购买车辆实际车况与我方质检报告严重不符',
                            '2. 购买车型实际年款/配置与购买时年款/配置不符',
                            '3. 购买车型在购买日期前里程表被更改',
                            '且以上任一情形我方未以书面形式告知你（购买方），我方同意对购买方购买车型原价(以原合同载明的转让价格为准)回购的解决方案。',
                            '您（购买方）同意所购买车型可能存在的以上三种情况不构成我方的欺诈行为。',
                        ]
                    },
                    {
                        title: '补偿标准',
                        content: [
                            '自购买协议签订日期起90天内我方对车辆原价回购，第91天0点开始，我方不再为您(购买方)购买的车辆可能存在的以上3种问题进行原价回购，将按照以下补偿内容承担责任。',
                            '1. 购买车型在购买日期前里程表被更改：',
                            '补偿标准：我方按照每公里1元进行补偿，最高补偿金额1万元，里程明确告知除外。',
                            '2. 购买车型实际年款/配置与购买时年款/配置不符',
                            '补偿标准：我方按照您所购买车辆指导价与车辆实际指导价的差额的50%进行补偿。',
                            '3. 购买车辆实际车况与我方质检报告严重不符',
                            '经有相关机动车鉴定资质的第三方公司鉴定，此车为D级事故车、火烧车、水泡车， 且我方质检报告当中未体现以上真实车况的，予以车况差额补偿。',
                        ]
                    },
                    {
                        title: '备注',
                        content: [
                            '1. 若您购买车型进行分期的，在享受我方提供的90天原价回购政策前，您（购买方）需自行结清分期贷款并承担贷款违约责任。',
                            '2. 如本协议约定的90天期间内，因您（购买方）原因造成影响甲方再次销售的车况改变，我方不再回购车辆，但非因您方（购买方）原因且符合本协议补偿标准的情形，我方依旧承担补偿责任。',
                            '3. 本协议期间内发生的纠纷双方应协商解决，如您（购买方）寻找媒体、舆论发酵纠纷事件，则我方不承担本协议项下任何责 任，您（购买方）可向法院起诉解决。',
                            '4. 如车辆存在本协议项下载明应补偿的情况，我方应按照本协议约定进行赔付，但您（购买方）向法院起诉索赔的情形应以法院出具的书面文书(判决书、裁定等)为准，本协议在您（购买方）向法院起诉时即刻失效。',
                            '5. 本协议与原合同不一致的，以原合同为准。',
                        ]
                    },
                ],
                
            }
            //  if (state.orderDate >= state.version240702 && state.orderDate <= state.version240704) {
            //     state.contentTextRender = state.contentText20240702;
            //  } else if (state.orderDate >= 20240514190000 || state.orderDate > state.version240704) {
            //     state.contentTextRender = state.contentText20240514;
            // } else {
            //     state.contentTextRender = state.contentText;
            // }
            state.contentTextRender = state.contentText;
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            },
        }
    })
